import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { mockDeals } from '../../mocks/travel';
import { mockHajjPackages } from '../../mocks/hajj-umrah';
import { useNavigate } from 'react-router-dom';

export default function PackagesPage() {
  const vacationPackages = [
    {
      id: 1,
      title: "Lagos Beach Getaway",
      location: "Lagos, Nigeria",
      duration: "4 days, 3 nights",
      price: 125000,
      originalPrice: 180000,
      rating: 4.6,
      reviews: 89,
      image: "https://readdy.ai/api/search-image?query=beautiful%20Lagos%20beach%20resort%20with%20palm%20trees%2C%20luxury%20accommodation%2C%20crystal%20clear%20water%2C%20tropical%20paradise%2C%20professional%20travel%20photography%2C%20warm%20golden%20lighting&width=400&height=300&seq=package1&orientation=landscape",
      includes: ["Round-trip flights", "4-star hotel", "Daily breakfast", "Airport transfers"],
      highlights: ["Tarkwa Bay Beach", "National Theatre", "Lekki Conservation Centre"]
    },
    {
      id: 2,
      title: "Abuja Cultural Experience",
      location: "Abuja, Nigeria",
      duration: "3 days, 2 nights",
      price: 95000,
      originalPrice: 135000,
      rating: 4.4,
      reviews: 67,
      image: "https://readdy.ai/api/search-image?query=modern%20Abuja%20cityscape%20with%20government%20buildings%2C%20cultural%20landmarks%2C%20beautiful%20architecture%2C%20professional%20travel%20photography%2C%20clear%20blue%20sky&width=400&height=300&seq=package2&orientation=landscape",
      includes: ["Round-trip flights", "3-star hotel", "City tour", "Cultural activities"],
      highlights: ["Aso Rock", "National Mosque", "Arts & Crafts Village"]
    },
    {
      id: 3,
      title: "Kano Heritage Tour",
      location: "Kano, Nigeria",
      duration: "5 days, 4 nights",
      price: 110000,
      originalPrice: 155000,
      rating: 4.5,
      reviews: 54,
      image: "https://readdy.ai/api/search-image?query=historic%20Kano%20city%20with%20traditional%20architecture%2C%20ancient%20walls%2C%20cultural%20heritage%20sites%2C%20professional%20travel%20photography%2C%20warm%20atmospheric%20lighting&width=400&height=300&seq=package3&orientation=landscape",
      includes: ["Round-trip flights", "Heritage hotel", "Guided tours", "Traditional meals"],
      highlights: ["Kano City Walls", "Kurmi Market", "Emir's Palace"]
    },
    {
      id: 4,
      title: "Dubai Shopping & Luxury",
      location: "Dubai, UAE",
      duration: "6 days, 5 nights",
      price: 450000,
      originalPrice: 620000,
      rating: 4.8,
      reviews: 156,
      image: "https://readdy.ai/api/search-image?query=Dubai%20luxury%20skyline%20with%20Burj%20Khalifa%2C%20modern%20architecture%2C%20shopping%20malls%2C%20professional%20travel%20photography%2C%20golden%20hour%20lighting%2C%20urban%20paradise&width=400&height=300&seq=package4&orientation=landscape",
      includes: ["Round-trip flights", "5-star hotel", "Desert safari", "Shopping tours"],
      highlights: ["Burj Khalifa", "Dubai Mall", "Palm Jumeirah"]
    }
  ];

  const packageTypes = [
    {
      icon: "ri-plane-line",
      title: "Flight + Hotel",
      description: "Complete packages with flights and accommodation",
      color: "bg-blue-600"
    },
    {
      icon: "ri-building-line",
      title: "Hajj & Umrah",
      description: "Sacred journey packages with complete guidance",
      color: "bg-green-600"
    },
    {
      icon: "ri-car-line",
      title: "All-Inclusive",
      description: "Everything included: flights, hotels, cars, and activities",
      color: "bg-purple-600"
    },
    {
      icon: "ri-map-pin-line",
      title: "City Breaks",
      description: "Short getaways to explore amazing cities",
      color: "bg-orange-600"
    },
    {
      icon: "ri-sun-line",
      title: "Beach Holidays",
      description: "Relaxing beach destinations with luxury resorts",
      color: "bg-yellow-600"
    },
    {
      icon: "ri-passport-line",
      title: "Visa-Free Destinations from Nigeria",
      description: "Travel without visa hassles to amazing destinations",
      color: "bg-red-600"
    }
  ];

  const navigate = useNavigate();

  const handlePackageTypeClick = (type: string) => {
    if (type === 'Visa-Free Destinations from Nigeria') {
      navigate('/general?filter=visa-free');
    }
  };

  const visaFreeDestinations = [
    {
      id: 1,
      name: "Ghana",
      duration: "90 days",
      region: "West Africa",
      image: "https://readdy.ai/api/search-image?query=beautiful%20Ghana%20Accra%20cityscape%20with%20modern%20buildings%2C%20Independence%20Square%2C%20vibrant%20culture%2C%20professional%20travel%20photography%2C%20warm%20tropical%20lighting&width=300&height=200&seq=visafree1&orientation=landscape",
      highlights: ["Kakum National Park", "Cape Coast Castle", "Accra Markets"]
    },
    {
      id: 2,
      name: "Kenya",
      duration: "60 days",
      region: "East Africa",
      image: "https://readdy.ai/api/search-image?query=Kenya%20Nairobi%20skyline%20with%20wildlife%20safari%20landscape%2C%20elephants%2C%20acacia%20trees%2C%20beautiful%20african%20scenery%2C%20professional%20travel%20photography%2C%20golden%20hour%20lighting&width=300&height=200&seq=visafree2&orientation=landscape",
      highlights: ["Maasai Mara", "Nairobi National Park", "Diani Beach"]
    },
    {
      id: 3,
      name: "Barbados",
      duration: "180 days",
      region: "Caribbean",
      image: "https://readdy.ai/api/search-image?query=Barbados%20tropical%20beach%20with%20turquoise%20water%2C%20white%20sand%2C%20palm%20trees%2C%20caribbean%20paradise%2C%20luxury%20resort%2C%20professional%20travel%20photography%2C%20bright%20sunny%20day&width=300&height=200&seq=visafree3&orientation=landscape",
      highlights: ["Carlisle Bay", "Harrison's Cave", "Oistins Fish Fry"]
    },
    {
      id: 4,
      name: "Senegal",
      duration: "90 days",
      region: "West Africa",
      image: "https://readdy.ai/api/search-image?query=Senegal%20Dakar%20cityscape%20with%20African%20Renaissance%20Monument%2C%20colorful%20markets%2C%20coastal%20views%2C%20vibrant%20culture%2C%20professional%20travel%20photography%2C%20warm%20lighting&width=300&height=200&seq=visafree4&orientation=landscape",
      highlights: ["Gorée Island", "Pink Lake", "Dakar Markets"]
    },
    {
      id: 5,
      name: "Rwanda",
      duration: "30 days",
      region: "East Africa",
      image: "https://readdy.ai/api/search-image?query=Rwanda%20Kigali%20modern%20city%20with%20green%20hills%2C%20mountain%20gorillas%20in%20forest%2C%20beautiful%20landscapes%2C%20professional%20travel%20photography%2C%20lush%20greenery&width=300&height=200&seq=visafree5&orientation=landscape",
      highlights: ["Volcanoes National Park", "Kigali Genocide Memorial", "Lake Kivu"]
    },
    {
      id: 6,
      name: "Seychelles",
      duration: "90 days",
      region: "Indian Ocean",
      image: "https://readdy.ai/api/search-image?query=Seychelles%20pristine%20beach%20with%20granite%20rocks%2C%20crystal%20clear%20turquoise%20water%2C%20tropical%20paradise%2C%20luxury%20island%20resort%2C%20professional%20travel%20photography%2C%20bright%20sunny%20day&width=300&height=200&seq=visafree6&orientation=landscape",
      highlights: ["Anse Source d'Argent", "Vallée de Mai", "Aldabra Atoll"]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-80 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=beautiful%20travel%20destination%20collage%20with%20multiple%20vacation%20spots%2C%20luxury%20resorts%2C%20cultural%20landmarks%2C%20adventure%20activities%2C%20professional%20travel%20photography&width=1200&height=320&seq=packagehero&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white max-w-4xl mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              All Travel Packages
            </h1>
            <p className="text-xl mb-8">
              Discover amazing vacation packages, Hajj & Umrah journeys, and complete travel experiences
            </p>
          </div>
        </div>
      </section>

      {/* Package Types */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Choose Your Package Type</h2>
            <p className="text-lg text-gray-600">Find the perfect travel package for your needs</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {packageTypes.map((type, index) => (
              <div 
                key={index} 
                className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow cursor-pointer border border-gray-200"
                onClick={() => handlePackageTypeClick(type.title)}
              >
                <div className={`w-12 h-12 ${type.color} rounded-lg flex items-center justify-center mb-4`}>
                  <i className={`${type.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{type.title}</h3>
                <p className="text-gray-600">{type.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vacation Packages */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900">Vacation Packages</h2>
            <Button variant="outline">View All Vacation Packages</Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {vacationPackages.map((pkg) => (
              <div key={pkg.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer">
                <div className="relative">
                  <img
                    src={pkg.image}
                    alt={pkg.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute top-3 left-3 bg-red-500 text-white px-2 py-1 rounded text-sm font-medium">
                    {Math.round(((pkg.originalPrice - pkg.price) / pkg.originalPrice) * 100)}% OFF
                  </div>
                </div>
                
                <div className="p-4">
                  <h3 className="font-semibold text-lg mb-1">{pkg.title}</h3>
                  <p className="text-gray-600 text-sm mb-2">{pkg.location} • {pkg.duration}</p>
                  
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-${i < Math.floor(pkg.rating) ? 'fill' : 'line'} text-sm`}></i>
                      ))}
                    </div>
                    <span className="text-sm text-gray-600 ml-1">({pkg.reviews})</span>
                  </div>
                  
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <span className="text-gray-500 line-through text-sm">₦{pkg.originalPrice.toLocaleString()}</span>
                      <span className="text-xl font-bold text-green-600 ml-2">₦{pkg.price.toLocaleString()}</span>
                    </div>
                  </div>
                  
                  <div className="space-y-1 mb-3">
                    {pkg.includes.slice(0, 2).map((item, index) => (
                      <div key={index} className="flex items-center text-xs text-gray-600">
                        <i className="ri-check-line text-green-500 mr-1"></i>
                        {item}
                      </div>
                    ))}
                  </div>

                  <Button size="sm" fullWidth>
                    View Package
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Visa-Free Destinations Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Visa-Free Destinations from Nigeria</h2>
            <p className="text-lg text-gray-600">Travel without visa hassles to these amazing destinations</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {visaFreeDestinations.map((destination) => (
              <div key={destination.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer border border-gray-200">
                <div className="relative">
                  <img
                    src={destination.image}
                    alt={destination.name}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute top-3 right-3 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    ✓ Visa-Free
                  </div>
                </div>
                
                <div className="p-5">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{destination.name}</h3>
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-sm text-gray-600">{destination.region}</span>
                    <span className="text-sm font-semibold text-blue-600">{destination.duration}</span>
                  </div>
                  
                  <div className="space-y-2 mb-4">
                    <p className="text-sm font-medium text-gray-700">Top Highlights:</p>
                    {destination.highlights.map((highlight, index) => (
                      <div key={index} className="flex items-center text-xs text-gray-600">
                        <i className="ri-map-pin-line text-blue-500 mr-2"></i>
                        {highlight}
                      </div>
                    ))}
                  </div>

                  <Button size="sm" fullWidth>
                    Explore {destination.name}
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Button variant="outline" onClick={() => navigate('/general?filter=visa-free')}>
              View All Visa-Free Countries
            </Button>
          </div>
        </div>
      </section>

      {/* Hajj & Umrah Packages */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900">Hajj & Umrah Packages</h2>
              <p className="text-lg text-gray-600 mt-2">Sacred journeys with complete peace of mind</p>
            </div>
            <Button variant="outline">View All Hajj/Umrah</Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {mockHajjPackages.map((pkg) => (
              <div key={pkg.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer">
                <div className="relative">
                  <img
                    src={pkg.image}
                    alt={pkg.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute top-3 left-3 bg-green-600 text-white px-2 py-1 rounded text-sm font-medium">
                    {pkg.discount}% OFF
                  </div>
                  <div className="absolute top-3 right-3 bg-blue-600 text-white px-2 py-1 rounded text-xs font-medium uppercase">
                    {pkg.type}
                  </div>
                </div>
                
                <div className="p-4">
                  <h3 className="font-semibold text-lg mb-1">{pkg.title}</h3>
                  <p className="text-gray-600 text-sm mb-2">{pkg.location} • {pkg.duration}</p>
                  
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-${i < Math.floor(pkg.rating) ? 'fill' : 'line'} text-sm`}></i>
                      ))}
                    </div>
                    <span className="text-sm text-gray-600 ml-1">({pkg.reviews})</span>
                  </div>
                  
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <span className="text-gray-500 line-through text-sm">${pkg.originalPrice}</span>
                      <span className="text-xl font-bold text-green-600 ml-2">${pkg.price}</span>
                    </div>
                  </div>
                  
                  <div className="flex flex-wrap gap-1 mb-3">
                    {pkg.features.slice(0, 2).map((feature, index) => (
                      <span key={index} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                        {feature}
                      </span>
                    ))}
                  </div>

                  <Button size="sm" fullWidth>
                    View Details
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Deals */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900">Special Deals</h2>
            <Button variant="outline">View All Deals</Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {mockDeals.map((deal) => (
              <div key={deal.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer">
                <div className="relative">
                  <img
                    src={deal.image}
                    alt={deal.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute top-3 left-3 bg-red-500 text-white px-2 py-1 rounded text-sm font-medium">
                    {deal.discount}% OFF
                  </div>
                </div>
                
                <div className="p-4">
                  <h3 className="font-semibold text-lg mb-1">{deal.title}</h3>
                  <p className="text-gray-600 text-sm mb-2">{deal.location}</p>
                  
                  {deal.rating && (
                    <div className="flex items-center mb-2">
                      <div className="flex text-yellow-400">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-${i < Math.floor(deal.rating) ? 'fill' : 'line'} text-sm`}></i>
                        ))}
                      </div>
                      <span className="text-sm text-gray-600 ml-1">({deal.reviews})</span>
                    </div>
                  )}
                  
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-gray-500 line-through text-sm">${deal.originalPrice}</span>
                      <span className="text-xl font-bold text-green-600 ml-2">${deal.salePrice}</span>
                    </div>
                  </div>
                  
                  <div className="flex flex-wrap gap-1 mt-2">
                    {deal.features.slice(0, 2).map((feature, index) => (
                      <span key={index} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}